import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './FolderPaywall';
import { showPremiumFolderPopup } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';

type StateProps = Pick<Props, never>;
type DispatchProps = Pick<Props, 'showPremiumFolderPopup'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  showPremiumFolderPopup,
};

export default connect(null, mapDispatchToProps);
